import utagLinkGeneric from './utagLinkGeneric';

function utagLinkHomepage (eventCategory = 'Homepage') {

	return ({ eventAction, eventLabel = '', nonInteraction = 0 }) => {

		utagLinkGeneric({
			eventCategory,
			eventAction,
			eventLabel,
			nonInteraction
		});

	};

}

export default utagLinkHomepage;
